export const PRIMARY_COLOR = 'rgb(110,180,50)';
export const PRIMARY_DARK_COLOR = 'rgb(80,140,40)';
export const SECONDARY_COLOR = 'rgb(40,80,150)';
export const SECONDARY_DARK_COLOR = 'rgb(27,54,100)';
export const SECONDARY_DARK_COLOR_TOP = 'rgba(20,40,80,0.9)';
export const GREY_COLOR = 'rgb(138, 138, 138)';
export const GREY_COLOR1 = 'rgb(241, 242, 243)';
export const LIGHT_LOADER_COLOR = 'rgba(138, 138, 138,0.3)';
export const WHITE_COLOR = 'rgb(255, 255, 255)';
export const BLACK_COLOR = 'rgb(0, 0, 0)';
export const BLACK_COLOR_LIGHT = 'rgba(0, 0, 0,0.4)';
export const BG_COLOR = 'rgb(230, 231, 235)';
export const LIGHT_GREY_COLOR = 'rgb(196, 196, 196)';
export const BLUE_COLOR = 'blue';
export const BLACK = 'black';
export const GREEN = 'green';
export const LIGHT_GRAY = 'rgb(211,211,211)';
export const WHITE = 'white';
export const WRONG_ANSWER_BACKGROUND_COLOR = 'rgb(192,66,83)';
export const VIDEO_DIM_COLOR = 'rgba(255,165,0,0.35)';
export const BG_ORANGE_COLOR = '#ff9501';
export const BG_DARK_GRAY_COLOR = '#2f2f2f';
export const SKIP_DONE_BUTTON = 'rgb(138,138,138)';
